import { render, staticRenderFns } from "./card1.vue?vue&type=template&id=018420ef&scoped=true&"
import script from "./card1.vue?vue&type=script&lang=js&"
export * from "./card1.vue?vue&type=script&lang=js&"
import style0 from "./card1.vue?vue&type=style&index=0&id=018420ef&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018420ef",
  null
  
)

export default component.exports